import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { CommentButtonPlaceholder } from './CommentButtonPlaceholder';

export const CommentIconLoadable = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentIcon" */ './CommentIcon')).CommentIcon,
	loading: () => <CommentButtonPlaceholder />,
});
